import { Grid, Paper, Typography } from "@mui/material";
import React, { useState } from "react";
import WSImageUpload from "../../Components/FileUpload/WSImageUpload";
import { useForm } from "react-hook-form";
import WSTextField, { TextType } from "../../Components/TextBox/WSTextBox";
import WSPhone from "../../Components/Phone/WSPhone";
import {
  customValidation,
  validations,
} from "../../commonFunctions/CommonFunctions";
import WSSelectField from "../../Components/Select/WSSelect";
import WSTextAreaField from "../../Components/WSTextArea/WSTextArea";
import WSFileUpload from "../../Components/FileUpload/WSFileUpload";
import WSButton from "../../Components/Button/WSButton";
import { useNavigate } from "react-router-dom";

export const BusinessDetails: React.FC<any> = React.memo((props) => {
  const { control, register,handleSubmit } = useForm();
    const [loading, setLoading] = useState(false);
  const navigate = useNavigate()

  const handleData = async (data: any) => {
    debugger;
    console.log("onsubmit===>", data); // You can perform any action with the submitted data here
  };
  
   const handleCancelClick = () => {
    navigate("/");
  };

  return (
    <Grid p={3}>
      <Paper
        elevation={0}
        style={{
          paddingLeft: 20,
          paddingRight: 20,
          marginTop: 0,
          paddingBottom: 25,
          borderRadius: "8px",
        }}
      >
        <Grid container spacing={2}>

          <Grid item xs={12}>
            <WSImageUpload
              control={control}
              id="addLogo"
              name="addLogo"
              label=""
              rules={{ required: false }}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <Grid container direction="column" spacing={2}>
                <Grid item>
                  <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>
                    {" "}
                    Business Details
                  </Typography>
                </Grid>
              <Grid item>
                <WSTextField
                  label={"Business Name *"}
                  {...register("businessName")}
                  id="businessName"
                  name="businessName"
                  control={control}
                  rules={{ required: true }}
                />
              </Grid>
              <Grid item>
                <WSPhone
                  label={"Phone Number"}
                  id={"phoneNumber"}
                  name={"phoneNumber"}
                  control={control}
                  rules={{ required: true }}
                />
              </Grid>
              <Grid item>
                <WSTextField
                  label={"GSTIN"}
                  {...register("gstIn")}
                  id="gstIn"
                  name="gstIn"
                  control={control}
                  rules={{ required: false }}
                />
              </Grid>
              <Grid item>
                <WSTextField
                  className="form-control"
                  id="email"
                  type={TextType.Text}
                  rules={customValidation(false, validations.email)}
                  {...register("email")}
                  label="Email Id"
                  control={control}
                />
              </Grid>
              <Grid item>
                <WSTextField
                  label={"Enter Drug License Number"}
                  {...register("druglicense")}
                  id="druglicense"
                  name="druglicense"
                  control={control}
                  rules={{ required: false }}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Grid container direction="column" spacing={2}>
                <Grid item>
                  <Typography sx={{ fontSize: "1rem", fontWeight: "bold" }}>
                    {" "}
                    More Details
                  </Typography>
                </Grid>
                <Grid item>
                     <WSSelectField
                rules={{ required: true }}
                control={control}
                id="type"
                {...register("type")}
                name="type"
                label="Business Type"
              />
                </Grid>
                <Grid item>
                     <WSSelectField
                rules={{ required: true }}
                control={control}
                id="category"
                {...register("category")}
                name="category"
                label="Business Category"
              />
                </Grid>
                 <Grid item>
                            <WSSelectField
                              rules={{ required: false }}
                              {...register("state")}
                              id="state"
                              control={control}
                              defaultValue={"0"}
                              label="State"
                              name="state"
                            />
                          </Grid>
                           <Grid item>
        <WSTextField
                  label={"Pin Code"}
                  {...register("pinCode")}
                  id="pinCode"
                  name="pinCode"
                  control={control}
                  rules={{ required: false }}
                />
          </Grid>
          <Grid item>
        <WSTextField
                  label={"FSSAI NO"}
                  {...register("fssaiNo")}
                  id="fssaiNo"
                  name="fssaiNo"
                  control={control}
                  rules={{ required: false }}
                />
          </Grid>
</Grid>
          </Grid>
              <Grid item xs={12} md={4} mt={5}>
        <Grid container direction="column" spacing={2}>
          <Grid item>
            <WSTextAreaField
              label={"Business Address"}
              id={"businessAddress"}
              name={"businessAddress"}
              control={control}
              rules={{ required: false }}
              rows={3}
            />
          </Grid>
          <Grid item>
           <WSFileUpload
                  name="signature"
                  label="Add signature"
                  control={control}
                  rules={{ required: false }}
                  acceptFileTypes=".jpg,.jpeg,.png"
                  maxFileSizeMB={2}
                  //  defaultValue={defaultImg}
                  id={"signature"}
                  image={true}
                  align="Start"
                  isToolTipImg={false}
                  multiple={true}
                />
          </Grid>
          </Grid>
        </Grid>
         <Grid container justifyContent="flex-end" spacing={2} sx={{ mt: 2 }}>
           <Grid item>
              <WSButton
                id="cancel"
                type="button"
                label="Cancel"
                size="medium"
                onClick={handleCancelClick}
                variant="outlined"
                color="primary"
                sx={{
                  borderRadius: 8,
                  width: "8rem",
                  border: "1px solid #098963",
                  color: "#098963",
                  backgroundColor: "#FFFFFF",
                }}
              />
            </Grid>

          <Grid item>
            <WSButton
              id="submit"
              type="submit"
              label="Save Changes"
              size="medium"
              variant="outlined"
              color="primary"
              loading={loading}
              onClick={handleSubmit(handleData)}
              sx={{
                  borderRadius: 8,
                border: "1px solid rgba(245, 66, 53, 1)",
                color: "#FFFFFF",
                  backgroundColor: "rgba(245, 66, 53, 1)",
                "&:hover": {
                  backgroundColor: "rgba(245, 66, 53, 1)",
                },
              }}
            />
          </Grid>
        </Grid>
        </Grid>
      </Paper>
      
    </Grid>
  );
});
